/**
 * This file is duplicated in these locations:
 * - functions/src/interface/signupForm/types.ts
 * - hosting/src/components/signupForm/types.ts
 *
 * Any changes need to be made in both files
 */

export enum ApplicationType {
  licensedMember = "licensedMember",
  representativeMember = "representativeMember",
}

export enum Title {
  mr = "Mr",
  miss = "Miss",
  mrs = "Mrs",
  ms = "Ms",
}

export enum PreferredMailingAddress {
  office = "office",
  other = "other",
}

export enum FunctionType {
  Auctioneering = "Auctioneering",
  OCM = "Owners Corporation Management",
  BB = "Business Broking",
  PV = "Property Valuations",
  BA = "Buyers Agency",
  RLM = "Residential Leasing & Management",
  CILM = "Commercial & Industrial Leasing & Management",
  RS = "Residential Sales",
  CIS = "Commercial & Industrial Sales",
  FRL = "Farming & Rural Lifestyle",
}

export interface SignupFormData {
  applicationType: ApplicationType | string;
  licenseNumber?: string;
  person: {
    title: Title;
    firstName: string;
    preferredName: string;
    middleName: string;
    lastName: string;
    dob: string;
    mobile: string;
    email: string;
  };
  business: {
    tradingName: string;
    address: string;
  };
  termsAndConditions: {
    reiv: boolean;
    hutly: boolean;
  };
  preferredMailing: {
    type: PreferredMailingAddress | string;
    value: string;
  };
  functions: FunctionType[] | string[];
}
